(function(){
  try {
    // inject CSS
    if (!document.getElementById('urge-funnel-fix-css')) {
      var l = document.createElement('link');
      l.id = 'urge-funnel-fix-css';
      l.rel = 'stylesheet';
      l.href = ('https://cdn.shopify.com/s/files/1/0636/6078/5735/t/3/assets/urge-funnel-fix.css') + '?v=' + Date.now();
      document.head.appendChild(l);
    }

    function ready(fn){
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function(){
      // Hide account chrome
      document.querySelectorAll('.account-button, .account-popover, .account-drawer').forEach(function(el){
        el.style.setProperty('display','none','important');
      });

      // Prefer single waitlist: if identity/primary form exists, soften bottom duplicate form
      var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="contact"] input[type="email"]'))
        .map(function(i){ return i.form; })
        .filter(Boolean);
      // unique forms
      forms = forms.filter(function(f, idx, arr){ return arr.indexOf(f) === idx; });
      if (forms.length > 1) {
        // keep first in document order (usually identity), convert others to "back to list" CTA
        forms.slice(1).forEach(function(f){
          var section = f.closest('section') || f.parentElement;
          if (!section) return;
          // Don't destroy PDP-only single forms if only one on pdp - already handled by length
          var note = document.createElement('p');
          note.className = 'urge-email__note';
          note.style.cssText = 'text-align:center;margin:1rem 0;';
          note.innerHTML = '<a href="#waitlist" style="color:inherit;font-weight:700;">One list only — jump to sign-up ↑</a>';
          f.style.display = 'none';
          if (!section.querySelector('.urge-dedupe-note')) {
            note.classList.add('urge-dedupe-note');
            f.parentNode.insertBefore(note, f.nextSibling);
          }
        });
      }

      // Ensure #waitlist points somewhere useful
      var wait = document.getElementById('waitlist') || document.querySelector('.urge-identity') || forms[0];
      if (wait && !document.getElementById('waitlist') && wait.id !== 'waitlist') {
        // leave as is
      }
    });
  } catch (e) {}
})();
